"use strict";
exports.__esModule = true;
var chance_1 = require("chance");
var utils_1 = require("./utils");
var species_1 = require("./species");
var mogwais_1 = require("./mogwais");
var strategies_1 = require("./strategies");
exports.gremlins = {
    species: {
        clicker: species_1.clicker,
        toucher: species_1.toucher,
        formFiller: species_1.formFiller,
        scroller: species_1.scroller,
        typer: species_1.typer
    },
    mogwais: {
        alert: mogwais_1.alert,
        fps: mogwais_1.fps,
        gizmo: mogwais_1.gizmo
    },
    strategies: {
        allTogether: strategies_1.allTogether,
        bySpecies: strategies_1.bySpecies,
        distribution: strategies_1.distribution
    },
    createHorde: function () { return new GremlinsHorde(); }
};
var GremlinsHorde = (function () {
    function GremlinsHorde() {
        this._gremlins = [];
        this._mogwais = [];
        this._strategies = [];
        this._beforeCallbacks = [];
        this._afterCallbacks = [];
        this._logger = console;
        this._randomizer = new chance_1.Chance();
    }
    GremlinsHorde.prototype.gremlin = function (gremlin) {
        this._gremlins.push(gremlin);
        return this;
    };
    GremlinsHorde.prototype.allGremlins = function () {
        for (var gremlinName in exports.gremlins.species) {
            this.gremlin(exports.gremlins.species[gremlinName]());
        }
        return this;
    };
    GremlinsHorde.prototype.mogwai = function (mogwai) {
        this._mogwais.push(mogwai);
        return this;
    };
    GremlinsHorde.prototype.allMogwais = function () {
        for (var mogwaiName in exports.gremlins.mogwais) {
            this.mogwai(exports.gremlins.mogwais[mogwaiName]());
        }
        return this;
    };
    GremlinsHorde.prototype.strategy = function (strategy) {
        this._strategies.push(strategy);
        return this;
    };
    GremlinsHorde.prototype.before = function (beforeCallback) {
        this._beforeCallbacks.push(beforeCallback);
        return this;
    };
    GremlinsHorde.prototype.after = function (afterCallback) {
        this._afterCallbacks.push(afterCallback);
        return this;
    };
    GremlinsHorde.prototype.logger = function (logger) {
        if (!logger) {
            return this._logger;
        }
        this._logger = logger;
        return this;
    };
    GremlinsHorde.prototype.log = function (msg) {
        this._logger.log(msg);
    };
    GremlinsHorde.prototype.randomizer = function (randomizer) {
        if (!randomizer) {
            return this._randomizer;
        }
        this._randomizer = randomizer;
        return this;
    };
    GremlinsHorde.prototype.seed = function (seed) {
        this._randomizer = new chance_1.Chance(seed);
        return this;
    };
    GremlinsHorde.prototype.unleash = function (params, done) {
        if (this._gremlins.length === 0) {
            this.allGremlins();
        }
        if (this._mogwais.length === 0) {
            this.allMogwais();
        }
        if (this._strategies.length === 0) {
            this.strategy(exports.gremlins.strategies.distribution());
        }
        var gremlinsAndMogwais = this._gremlins.concat(this._mogwais);
        var allCallbacks = gremlinsAndMogwais.concat(this._strategies, this._beforeCallbacks, this._afterCallbacks);
        utils_1.inject({ logger: this._logger, randomizer: this._randomizer }, allCallbacks);
        var beforeCallbacks = this._beforeCallbacks.concat(this._mogwais);
        var afterCallbacks = this._afterCallbacks;
        for (var i = 0, count = gremlinsAndMogwais.length; i < count; i++) {
            if (typeof gremlinsAndMogwais[i].cleanUp === "function") {
                afterCallbacks.push(gremlinsAndMogwais[i].cleanUp);
            }
        }
        var horde = this;
        utils_1.executeInSeries(beforeCallbacks, [], horde, function () {
            utils_1.executeInSeries(horde._strategies, [horde._gremlins, params], horde, function () {
                utils_1.executeInSeries(afterCallbacks, [], horde, function () {
                    if (typeof done === "function") {
                        done();
                    }
                });
            });
        });
    };
    GremlinsHorde.prototype.stop = function () {
        for (var i = 0, count = this._strategies.length; i < count; i++) {
            this._strategies[i].stop();
        }
    };
    return GremlinsHorde;
}());
exports.GremlinsHorde = GremlinsHorde;
